import React from 'react';
import PopupBase from '../base/PopupBase';
import CustomButton from '../../components/buttons/CustomButton';
import BodyMeasurementHistory from '../../pages/appointment/components/bodyMeasurements/BodyMeasurementHistory';
import { getMeasureInfo } from '../../pages/appointment/components/bodyMeasurements/bodyMeasurementsMath';

/**
 * Histórico completo de uma medida em popup: gráfico nas datas reais e lista
 * de valores. `onEdit(assessment)` é chamado ao escolher editar uma avaliação
 * (quem abre o popup fecha este e abre o formulário).
 */
function BodyMeasurementHistoryPopup({ history, measureKey, enabled, onEdit, OnHide }) {
  const info = getMeasureInfo(measureKey);

  const footer = (
    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
      <CustomButton variant="outlined" style="secondary" label="Fechar" onClick={() => OnHide()} />
    </div>
  );

  return (
    <PopupBase
      Title={`Histórico · ${info ? info.label : ''}`}
      Content={<BodyMeasurementHistory history={history} measureKey={measureKey} enabled={enabled} onEdit={onEdit} />}
      Footer={footer}
      OnClose={() => OnHide()}
      maxWidth="md"
    />
  );
}

export default BodyMeasurementHistoryPopup;
